import useSWR from "swr";
import { useCreateProductServiceAdminAxiosInstance } from "../../Auth/useCreateProductServiceAdminAxiosInstance.ts";
import { NormasTeachingBundleDTO } from "./useNormasTeachingBundleById.ts";

/** Stable identity: a fresh `[]` per render would churn every memo built on it. */
const NO_BUNDLES: NormasTeachingBundleDTO[] = [];

export function useAllNormasTeachingBundles({
  search,
  enabled = true,
}: { search?: string; enabled?: boolean } = {}) {
  const { createAxiosInstance } = useCreateProductServiceAdminAxiosInstance();
  const { data, error, isLoading } = useSWR(
    enabled ? [`/bundles`, search] : null,
    async ([url]) => {
      const { data } = await createAxiosInstance().get<{
        bundles: NormasTeachingBundleDTO[];
      }>(url, { params: { ...(search && { search }) } });

      return data;
    },
    { keepPreviousData: true },
  );

  return {
    bundles: data?.bundles ?? NO_BUNDLES,
    error,
    isLoading: isLoading && data === undefined,
  };
}
